import {Component, OnInit} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Router} from "@angular/router";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  errorMessage: string;
  success: boolean = false;
  registerForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [
      Validators.required,
      Validators.email
    ]),
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(8)
    ]),
    name: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(2)
    ])
  });

  constructor(private authService: AngularFireAuth, private db: AngularFirestore, private router: Router) {
  }

  ngOnInit() {
  }

  onSubmit() {
    this.registerForm.disable({});
    this.authService.createUserWithEmailAndPassword(this.registerForm.value.email, this.registerForm.value.password)
      .then(res => {
        this.db.collection('users')
          .doc(res.user.uid)
          .set({
            displayName: this.registerForm.value.name
          }, {
            merge: true
          }).then(() => {
          this.router.navigateByUrl('/recepten');
        }, error => {
          this.errorMessage = error;
        });
      }, error => {
        this.errorMessage = error;
      })
  }

}
